(() => {
  if (customElements.get('ph-product-dock')) return;

  class PhProductDock extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.productInfo = this.closest('product-info');
      this.action = this.querySelector('[data-dock-action]');
      this.variant = this.querySelector('[data-dock-variant]');
      this.price = this.querySelector('[data-dock-price]');
      if (!this.productInfo || !this.action || !this.price) return;
      try {
        this.variantData = JSON.parse(this.querySelector('[data-dock-prices]')?.textContent || '{}').variants || {};
      } catch {
        this.variantData = {};
      }

      this.mobile = matchMedia('(max-width: 749px)');
      this.abort = new AbortController();
      this.update = () => {
        if (!this.isConnected) return;
        this.updateContent();
        const button = this.submit?.getBoundingClientRect();
        const product = this.productInfo.getBoundingClientRect();
        this.hidden = !this.mobile.matches || !button || button.bottom >= 8 || product.bottom <= 80 ||
          this.priceUnverified || document.body.classList.contains('overflow-hidden');
      };
      this.queueUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };

      this.action.addEventListener('click', () => {
        this.updateContent();
        if (!this.action.disabled && !this.priceUnverified) this.submit.click();
      }, { signal: this.abort.signal });
      this.productInfo.addEventListener('change', this.queueUpdate, { signal: this.abort.signal });
      window.addEventListener('scroll', this.queueUpdate, { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', this.queueUpdate, { passive: true, signal: this.abort.signal });
      this.mobile.addEventListener('change', this.queueUpdate);

      this.observer = new MutationObserver((records) => {
        if (records.some(record => !this.contains(record.target))) this.queueUpdate();
      });
      this.observer.observe(this.productInfo, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'value', 'checked', 'selected']
      });
      this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.update();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.mobile?.removeEventListener('change', this.queueUpdate);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    updateContent() {
      this.form = this.productInfo.querySelector('product-form form[data-type="add-to-cart-form"]');
      this.submit = this.form?.querySelector('button[name="add"]');
      const busy = this.submit?.getAttribute('aria-disabled') === 'true';
      this.action.disabled = !this.submit || this.submit.disabled || busy;
      this.action.setAttribute('aria-busy', String(busy));
      const label = this.submit?.querySelector('span')?.textContent?.trim() || this.dataset.addLabel;
      if (label && this.action.textContent !== label) this.action.textContent = label;

      const variantId = this.form?.elements.namedItem('id')?.value;
      const selectedVariant = this.variantData[variantId];
      if (this.variant && this.variant.textContent !== (selectedVariant?.title || '')) {
        this.variant.textContent = selectedVariant?.title || '';
      }

      const sellingPlan = this.form?.elements.namedItem('selling_plan');
      const subscriptionChoice = [...this.productInfo.querySelectorAll('input[type="radio"]:checked')]
        .some(input => /subscribe|subscription/i.test(input.labels?.[0]?.textContent || ''));
      if ((sellingPlan?.value && !sellingPlan.disabled) || subscriptionChoice) {
        this.priceUnverified = true;
        return;
      }
      const priceBox = this.productInfo.querySelector('[id^="price-"] .price');
      const amount = priceBox?.classList.contains('price--on-sale')
        ? priceBox.querySelector('.price__sale .price-item--sale')
        : priceBox?.querySelector('.price__regular .price-item--regular');
      const displayed = amount?.textContent?.replace(/\s+/g, ' ').trim();
      const normalize = value => (value || '').replace(/\s+/g, '');
      this.priceUnverified = !selectedVariant?.price || !displayed ||
        normalize(displayed) !== normalize(selectedVariant.price);
      if (displayed && this.price.textContent !== displayed) this.price.textContent = displayed;
    }
  }

  customElements.define('ph-product-dock', PhProductDock);
})();
